/**
 * Created by jonas on 2021-03-05.
 */

import {gsap} from "gsap";
import {DasUBootGameAssets} from "../../DasUBootGameAssets";
import {DasUBoot} from "../../DasUBoot";
import {MechanicalCounter, MechanicalCounterMode, MechanicalCounterTextureSet} from "./MechanicalCounter";
import {DasUBootSound} from "../../sound/DasUBootSound";
import {SpineGSAPWrapper} from "../../../core/animation/SpineGSAPWrapper";

export class XBombMultiplierDisplay extends PIXI.Container {
    private multiplier:number = 0;
    private counter:MechanicalCounter;
    private counterContainer:PIXI.Container;
    private counterPos:PIXI.Point;
    private meterSpine:PIXI.spine.Spine;
    private loop:gsap.core.Timeline;
    private counterSlotContainer:PIXI.Container;
    private currentLoopAnimation:string;

    constructor() {
        super();
        this.init();
    }

    private init() {
        this.counterContainer = new PIXI.Container();
        this.counterContainer.position.set(197, 273);
        this.counterContainer.scale.set(1, -1);

        this.counterPos = new PIXI.Point(640, 61);

        const textures:MechanicalCounterTextureSet = {
            background:DasUBoot.assetLoader.getTextures(DasUBootGameAssets.MULTIPLIER_COUNTER_BG)[0],
            numbers:DasUBoot.assetLoader.getTextures(DasUBootGameAssets.MULTIPLIER_COUNTER_NUMBERS)[0],
            overlay:DasUBoot.assetLoader.getTextures(DasUBootGameAssets.MULTIPLIER_COUNTER_OVERLAY)[0],
        }


        this.counter = new MechanicalCounter(2, textures, new PIXI.Point(38, 85), 40, MechanicalCounterMode.REPEAT);
        this.counterContainer.addChild(this.counter);

        this.meterSpine = new PIXI.spine.Spine(DasUBoot.assetLoader.getSpineAsset(DasUBootGameAssets.XBOMB_METER_SPINE));
        this.meterSpine.position.set(432, 308);
        this.meterSpine.autoUpdate = false;
        this.addChild(this.meterSpine);

        let index = this.meterSpine.skeleton.findSlotIndex('NUMBER_CONTAINER');
        this.counterSlotContainer = this.meterSpine.slotContainers[index];
        this.counterSlotContainer.addChild(this.counterContainer);

        this.setMultiplier(0);
    }

    private getAnimForValue(value:number):string {
        if (value >= 2) {
            if (value > 9) {
                value = 9;
            }
            return "xBombFire_x" + value;
        }

        return "idlexBombMeeter";
    }

    private setLoop(anim:string) {
        if (this.currentLoopAnimation == anim) {
            return;
        }

        if (this.loop) {
            this.loop.kill();
        }

        if (anim != "none") {
            const tl = gsap.timeline({repeat:-1});
            tl.add(SpineGSAPWrapper.createTimelineForAnimation(this.meterSpine, 0, anim));
            tl.add(() => {this.counterSlotContainer.addChild(this.counterContainer)}, 0.0001);
            this.loop = tl;
        }
        this.currentLoopAnimation = anim;
    }

    public setMultiplier(value:number, skipSound:boolean = false):gsap.core.Animation {
        const tl:gsap.core.Timeline = gsap.timeline();
        const update = value != this.multiplier && value != 0 && !skipSound;
        this.multiplier = value;

        if (update) {
            tl.add(() => {
                DasUBoot.soundPlayer.playSound(DasUBootSound.X_BOMB_COUNTER_UPDATE);
                this.meterSpine.state.setAnimation(1, "xBombExplosion", false);
                this.meterSpine.state.setAnimation(2, "xBomb_commonSmoke", false);
            });
        }

        tl.add(() => this.setLoop(this.getAnimForValue(this.multiplier)));
        tl.add(this.counter.setValue(value));

        if (update) {
            tl.add(() => DasUBoot.soundPlayer.playSound(DasUBootSound.X_BOMB_COUNTER_TICK), 0.1);
        }

        return tl;

    }

    public incrementMultiplier(duration:number, fromPos:PIXI.Point):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        if (this.multiplier == 0) {
            tl.add(this.setMultiplier(this.multiplier + 2));
        } else {
            tl.add(this.setMultiplier(this.multiplier + 1));
        }
        tl.add(DasUBoot.reelView.reelFrame.getFlashAnimation(duration, fromPos, this.counterPos), "<");

        return tl;
    }


}